import { Component, ChangeDetectionStrategy, input, computed, inject } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ChartModule } from 'primeng/chart';
import { WalletRecap } from '../../models/wallet-recap.model';
import { WalletStoreService } from '../../services/etiquette-service/wallet-store.service';

@Component({
  selector: 'spike-wallet-pie-chart',
  templateUrl: './wallet-pie-chart.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: true,
  imports: [CommonModule, ChartModule]
})
export class WalletPieChartComponent {
  public readonly walletStoreService = inject(WalletStoreService);

  
  public walletRecap = input.required<WalletRecap[]>();

  // Computed per i dati del grafico
  public readonly chartData = computed(() => {
    const data = this.walletRecap();
    if (!data || data.length === 0) return null;

    const filteredData = data
      .filter(w => (w.liquidityAmount + w.investmentAmount) > 0)
      .sort((a, b) => (b.liquidityAmount + b.investmentAmount) - (a.liquidityAmount + a.investmentAmount));

    return {
      labels: filteredData.map(w => this.walletStoreService.findReactive(w.finWalletId)()?.shortDescription|| 'Wallet'), // Assicurati che 'nome' esista nel modello
      datasets: [
        {
          data: filteredData.map(w => w.liquidityAmount + w.investmentAmount),
          backgroundColor: ['#42A5F5', '#66BB6A', '#FFA726', '#26C6DA', '#7E57C2'], // Array di colori consigliato
          hoverBackgroundColor: ['#64B5F6', '#81C784', '#FFB74D', '#4DD0E1', '#9575CD']
        }
      ]
    };
  });

  // Opzioni separate
  public readonly chartOptions = {
    responsive: true,
    maintainAspectRatio: true, // Mantiene il cerchio perfetto
    aspectRatio: 1,            // Forza un rapporto 1:1 (quadrato)
    plugins: {
      legend: {
        position: 'bottom',    // Spostandola sotto, il cerchio ha più spazio ai lati per centrarsi
        labels: {
          pointStyle: 'circle',
          usePointStyle: true,
          padding: 20          // Distanza tra legenda e grafico
        }
      }
    },
    layout: {
      padding: 10              // Evita che i bordi del grafico tocchino i margini del div
    }
  }
}